import BlueButton from "../../../../common/BlueButton/BlueButton";
import BlueCheckBox from "../../../../common/BlueCheckBox";
import BlueInputFile from "../../../../common/BlueInputFile";
import Container from "../../../../common/Container";
import InputBar from "../../../../common/InputBar";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";

const ImageUploaderDisplay = ({
    convertFile,
    nameInput,
    isButtonUploadGray,
    uploadTemplate,
    setNameInput,
    uploadMessage,
    uploadFileData,
    removeSetImage,
    isPublicUpload,
    setIsPublicUpload,
}) => {
    const { t } = useTranslation("templatesPage");

    const onDragOverEvent = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const onDropEvent = (e) => {
        e.preventDefault();
        convertFile(e.dataTransfer, "dragEvent");
    };

    const setIsPublic = useCallback(() => {
        if (isPublicUpload) {
            setIsPublicUpload(false);
        } else {
            setIsPublicUpload(true);
        }
    }, [isPublicUpload, setIsPublicUpload]);

    let moreOptions = (
        <>
            <div className="UploadMainContentInputAndButton">
                <div className="uploadMainImageDisplayXButton">
                    <BlueButton
                        text="X"
                        isDark={true}
                        onClick={() => removeSetImage()}
                    />
                </div>
                <img
                    className="uploadMainImageDisplay"
                    alt="imageUploadPreview"
                    src={"data:image/jpeg;base64," + uploadFileData}
                ></img>
                <p className="NoteTextUploadedimage">
                    {t("uploadPageNoteText")}
                </p>
                <BlueCheckBox
                    text={t("uploadPageAddToPublicLibarary")}
                    id="privateCheck"
                    onChange={setIsPublic}
                    defaultChecked={isPublicUpload}
                />
                <br />
                <br />
                <InputBar
                    placeholder={t("uploadPageName")}
                    onInput={(e) => setNameInput(e.target.value)}
                    value={nameInput}
                />
                <BlueButton
                    text={t("uploadButton")}
                    isGray={isButtonUploadGray}
                    onClick={() => uploadTemplate(isPublicUpload)}
                />
            </div>
            <br />
        </>
    );

    let uploadOption = (
        <>
            <div
                className="uploadMainContentDragAndDropContainer"
                onDragOver={(e) => onDragOverEvent(e)}
                onDrop={(e) => onDropEvent(e)}
            >
                <BlueInputFile
                    text={t("uploadPageDragAndDrop")}
                    onChange={(e) => convertFile(e)}
                />
            </div>
        </>
    );

    let content = (
        <Container
            content={<>{uploadFileData ? moreOptions : uploadOption}</>}
        />
    );

    if (uploadMessage) content = <Container content={<p>{uploadMessage}</p>} />;
    return content;
};

export default ImageUploaderDisplay;
